var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import cx from 'clsx';
import { InputLabel } from '../input_label/InputLabel';
import { useRadioGroup } from '../radio_group/RadioGroup';
import { customRadioVariants, focusRingStyles, inputVariants, radioDotSelectedStyles, radioDotVariants, wrapperStyles, } from './Radio.css';
const getCustomRadioVariant = (hasError, disabled) => {
    if (disabled) {
        return 'disabled';
    }
    return hasError ? 'hasError' : 'default';
};
const RadioComponent = React.forwardRef(function Radio(_a, ref) {
    var { className, id, value } = _a, rest = __rest(_a, ["className", "id", "value"]);
    const { hasError, isDisabled, name, onChange, selectedValue } = useRadioGroup();
    const isSelected = String(selectedValue) === String(value);
    return (_jsxs("div", { className: cx(wrapperStyles, className), children: [_jsx("input", Object.assign({}, rest, { checked: isSelected, className: inputVariants[isDisabled ? 'disabled' : 'default'], disabled: isDisabled, id: id, name: name, onChange: onChange, ref: ref, type: "radio", value: value })), _jsx("div", { className: focusRingStyles }), _jsx("div", { className: customRadioVariants[getCustomRadioVariant(hasError, isDisabled)], children: _jsx("div", { className: cx(radioDotVariants[isDisabled ? 'disabled' : 'default'], isSelected && radioDotSelectedStyles) }) })] }));
});
const RadioLabel = React.forwardRef(function RadioLabel(_a, ref) {
    var { children } = _a, rest = __rest(_a, ["children"]);
    const { isDisabled } = useRadioGroup();
    return (_jsx(InputLabel, Object.assign({ isDisabled: isDisabled }, rest, { ref: ref, children: children })));
});
export const Radio = RadioComponent;
Radio.Label = RadioLabel;
